<template>
	<TabWrapper @save="submit" @change="change" @deploy:preview="submit('preview')"
							@deploy:live="submit('live')" :hideButtonRowMargin="true" :subTab="tabs[tab].value">
		<v-container fluid style="padding-top:0;" ref="container">
			<v-tabs class="borderTopRadius" v-model="tab" :color="ada.pink" show-arrows ref="tabHeader"
							background-color="#d7036408" style="width: fit-content">
				<v-tabs-slider :color="ada.pink"></v-tabs-slider>
				<v-tab flat v-for="tab in tabs" :key="tab.name">
					{{ tab.name }}
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab" ref="tabContent" class="borderBottomRadius">
				<v-tab-item v-for="tab in tabs" :key="tab.value">
					<v-row>
						<v-col>
							<AceEditor
								v-model="content[tab.value]"
								@init="editorInit($event, tab.value)"
								lang="css"
								theme="chrome"
								width="100%"
								height="540"
								style="margin-top:16px"
								:options="aceConfig(tab.value)"
								:commands="[{
                            name: 'save',
                            bindKey: { win: 'Ctrl-s', mac: 'Command-s'},
                            exec: submit,
                        }]"
							/>
						</v-col>
					</v-row>
				</v-tab-item>
			</v-tabs-items>
			<div
				v-if="siteDetails &&
                (typeof siteDetails[currentTab.value === 'local' ? 'Css' : 'NativeCss'] !== 'undefined' ?
                siteDetails[currentTab.value === 'local' ? 'Css' : 'NativeCss'] : null)"
				class="mt-2">Zuletzt geändert
				am: {{ lastEdited }}
			</div>
		</v-container>
	</TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import AceEditor from 'vuejs-ace-editor';
import Utils from "../../../scripts/Utils";
import ada from '../../../scss/ada_colors.scss';

export default {
	name: "LocalCss",
	components: {TabWrapper, AceEditor},
	props: ['readOnly'],
	data: () => {
		return {
			ada,
			content: {local: null, native: null},
			editor: {local: null, native: null},
			tab: 0,
			tabs: [
				{name: 'Local.css', value: 'local'},
				{name: 'Native.css', value: 'native'}
			],
			disabled_rules: ['vendor-prefix', 'box-sizing', 'gradients', 'compatible-vendor-prefixes', 'unqualified-attributes', 'regex-selectors', 'universal-selector', 'overqualified-elements', 'floats', 'font-sizes', 'ids', 'important', 'order-alphabetical', 'adjoining-classes'],
		}
	},
	mounted() {
		this.init();
		this.$emit('activeComponent', this);
		if (this.$store.state.users.role === 'native') {
			this.tab = 1;
		}
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		currentTab() {
			return this.tabs[this.tab];
		},
		lastEdited() {
			if (this.siteDetails) {
				let siteDetails = this.siteDetails[this.currentTab.value === 'local' ? 'Css' : 'NativeCss'];
				if (siteDetails.Updated && siteDetails.Created) {
					return Utils.formatDate((new Date(siteDetails.Updated) > new Date(siteDetails.Created) ? siteDetails.Updated : siteDetails.Created), true);
				} else if (siteDetails.Updated !== null) {
					return Utils.formatDate(siteDetails.Updated);
				} else if (siteDetails.Created !== null) {
					return Utils.formatDate(siteDetails.Created);
				}
			}
			return '';
		}
	},
	methods: {
		init() {
			if (this.siteDetails) {
				this.content.local = Utils.htmlDecode(this.siteDetails.Css.Value);
				this.content.native = typeof this.siteDetails.NativeCss !== "undefined" ? Utils.htmlDecode(this.siteDetails.NativeCss.Value) : null;
			}
		},
		editorInit: function (editor, type = 'local') {
			this.editor[type] = editor;
			//CSSLint options https://github.com/CSSLint/csslint/wiki/rules
			editor.session.on("changeMode", (e, session) => {
				session.$worker.call('setDisabledRules', [this.disabled_rules.join('|')]);
			})
			require('brace/ext/language_tools') //language extension prerequsite...
			require('brace/mode/css')    //language
			require('brace/snippets/css')
			require('brace/theme/chrome')
		},
		validateCode() {
			if (this.editor[this.currentTab.value] && this.editor[this.currentTab.value].getSession().getAnnotations().filter(x => x.type === 'error').length !== 0) {
				this.$emit('error', this);
				this.$root.$emit('snackbar', 'Fehler in der ' + this.currentTab.name + ' gefunden. Bitte behebe alle Fehler.', 'error');
				return false;
			} else {
				return true;
			}
		},
		submit(type = '') {
			if (this.validateCode()) {
				if (type === 'preview') {
					this.$emit('deploy:preview', this);
				} else if (type === 'live') {
					this.$emit('deploy:live', this);
				} else {
					this.$emit('submit', this);
				}
			}
		},
		change() {
			if (this.vuexState.previousTab === this.$options._componentTag) {
				this.$emit('change', this);
			} else if (this.activeTab === this.$options._componentTag) {
				this.$emit('activeComponent', this);
			}
		},
		dataChanged() {
			let changed = false;
			if (this.content.local !== Utils.htmlDecode(this.siteDetails.Css.Value) ||
				this.content.native !== (typeof this.siteDetails.NativeCss !== "undefined" ? Utils.htmlDecode(this.siteDetails.NativeCss.Value) : null)) {
				changed = true;
			}
			return changed;
		},
		getBody() {
			let ret = {
				publisher_id: this.siteDetails.Site.PublisherId,
				site_id: this.siteDetails.Site.SiteId,
				type_id: this.siteDetails.Current.SitetypeId,
			};
			if (this.currentTab.value === 'native') {
				ret.NativeCss = this.content.native;
			} else {
				ret.Css = this.content.local;
			}
			return ret;
		},
		aceConfig(subTab) {
			let ret = JSON.parse(JSON.stringify(this.$store.state.aceConfig));
			if (this.$store.state.users.role === 'native' && subTab === 'native') {
				ret.readOnly = false;
			} else {
				ret.readOnly = this.readOnly;
			}
			return ret;
		},
	},
	watch: {
		siteDetails() {
			this.init();
		}
	},
}
</script>

<style scoped>

</style>